import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { EventType, roomService } from '../../services';
import { useI18n } from '../../locales';
import TuiDialog from '../common/base/Dialog';
import TuiButton from '../common/base/Button.vue';
import TuiInput from '../common/base/Input';
import CloseInputIcon from '../common/icons/CloseInputIcon.vue';
import { useBasicStore } from '../../stores/basic';
import svgIcon from '../common/base/SvgIcon.vue';
import { invalidPasswordRegex } from '../../utils/common';

interface Props {
  visible: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordDialog',
  props: {
    visible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  visible: boolean;
};

const basicStore = useBasicStore();
const { roomId } = storeToRefs(basicStore);

const { t } = useI18n();
const inputPassword: Ref<string> = ref('');

const isShowPasswordContainer = ref(false);

watch(
  () => props.visible,
  val => {
    isShowPasswordContainer.value = val;
  },
  {
    immediate: true,
  }
);

async function joinRoom() {
  await roomService.join(roomId.value, {
    isOpenCamera: false,
    isOpenMicrophone: true,
    password: inputPassword.value,
  });
  roomService.emit(EventType.ROOM_JOIN);
}

function cancelInputPassword() {
  inputPassword.value = '';
  roomService.emit(EventType.ROOM_ERROR);
}

watch(
  () => inputPassword.value,
  async (newValue, oldValue) => {
    if (newValue && invalidPasswordRegex.test(newValue)) {
      await nextTick();
      inputPassword.value = newValue.replace(invalidPasswordRegex, '');
    }
  }
);

return { __sfc: true,basicStore, roomId, t, inputPassword, props, isShowPasswordContainer, joinRoom, cancelInputPassword, TuiDialog, TuiButton, TuiInput, CloseInputIcon, svgIcon }
}

})